import React, { useEffect } from "react";

import CaseHealth from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/CaseHealth";
import Navigation from "../../../../../components/navigations/client/detail/case/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(2);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/case/case-health");
  }, []);

  return (
    <Navigation activeTab="case-health" _case={_case}>
      <CaseHealth />
    </Navigation>
  );
};
